<template>

    <v-container class="fill-height" style="display: block;" fluid>

        <div class="no-special-reports-text" v-if="!specialReportsTypes.length">
            <p>
                No Special Reports are Setup.
            </p>
        </div>

        <v-stepper class="stepper" style="background: #424242" v-model="currentStep" v-if="specialReportsTypes.length">
            <v-stepper-header style="height: 50px;">
                <v-stepper-step class="stepper-step" step="1" :complete="currentStep > 1" editable :color="'#c42111'">Special Report Type</v-stepper-step>
                <v-divider style="margin: 0px -6px;"></v-divider>
                <v-stepper-step class="stepper-step" step="2" :complete="currentStep > 2" editable :color="'#c42111'">Report Params</v-stepper-step>
                <v-divider style="margin: 0px -6px;"></v-divider>
                <v-stepper-step class="stepper-step" step="3" :complete="currentStep > 3" editable :color="'#c42111'">Report Results</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items class="stepper-content-container">

                <v-stepper-content :step="1" class="stepper-content">
                    <v-row dense no-gutters>
                        <v-col cols="12" lg="12" v-for="specialReportType in specialReportsTypes" :key="specialReportType.value">
                            <div class="list-report-container mb-2" @click="getSpecialReportInfo(specialReportType)" color="#303030">
                                <v-row dense no-gutters>
                                    <v-col cols="12">
                                        <span class="report-title" v-text="specialReportType.text" />
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="thresrept-files-button" v-if="true" @click="getFileBrowserData">
                        <span class="mt-2"><v-icon class="mb-1">mdi-file</v-icon> Browse User Threshold Files</span>
                    </div>
                    <span class="getting-files-list-text" v-if="gettingThresReptFileList">
                        Getting file list...
                        <v-icon>fas fa-spinner fa-spin</v-icon>
                    </span>

                    <div class="thresrept-files-container" v-if="showThresReptFileBrowser">
                        <v-treeview :items="thresreptFiles" item-children="files" item-key="name">
                            <template v-slot:label="{ item, open }">
                                <template v-if="item.files">
                                    <span><v-icon>mdi-account</v-icon>{{item.name}}</span>
                                </template>
                                <template v-else>
                                    <v-icon>{{getFileIcon(item.name)}}</v-icon><span class="download-link" @click="downloadThresreptFile(item.user, item.name)">{{item.name}}</span><span>{{getPrettyFileSize(item.size)}}</span>
                                </template>
                            </template>
                        </v-treeview>
                    </div>

                </v-stepper-content>

                <v-stepper-content :step="2" class="stepper-content">
                    <span class="placeholder-text" v-if="!selectedReportType">Please select a special report type first</span>
                    <v-row v-if="selectedReportType">
                        <v-col cols="12" lg="12" v-for="param in selectedReportInfo" :key="param.name">
                            <v-autocomplete autocomplete="off" :label="param.name" color="#c42111" v-model="param.value" :items="param.vals" @change="updateSpecialReportParams(param)" :rules="[validation.required(param.value, param.name)]" />
                        </v-col>
                    </v-row>
                    <v-btn class="mt-4" color="#c42111" @click="runSpecialReport" v-if="selectedReportType">Run Special Report</v-btn>
                    <div class="no-results" v-if="noResults">
                        <v-icon class="mr-2 mb-1">mdi-information</v-icon>
                        <span>No Results Found</span>
                    </div>
                </v-stepper-content>

                <v-stepper-content :step="3" class="stepper-content less-pad">
                    <span class="placeholder-text" v-if="!htmlReportResults && !gridReportResults">Please run a special report first</span>
                    <div v-if="htmlReportResults">
                        <div class="results-header">
                            <h1 v-text="this.selectedReportTypeName"></h1>
                            <span v-text="paramsText" />
                            <v-btn class="print" fab dark small color="#c42111" @click="printSpecialReportResults"><v-icon>mdi-printer</v-icon></v-btn>
                        </div>
                        <div class="results-container" v-html="htmlReportResults" />
                    </div>


                    <div v-if="gridReportResults">
                        <report-results :selectedReport="selectedGridReportResult" :reportDetails="''" :reportData="selectedGridReportResult" :runReportHumanText="selectedGridReportResult.thres_human_params" 
                            :runReportParams="''" :specialReportsList="gridReportResults" @specialReportChange="reloadReportResults" @showParams="showReportInfo = true" @notes="showReportNotes = true" v-if="showSpecialReportResults">
                        </report-results>
                    </div>
                </v-stepper-content>

            </v-stepper-items>
        </v-stepper>

        <v-dialog v-model="showReportInfo" max-width="80%" width="1200px" persistent v-if="showReportInfo">
            <v-card>
                <v-card-title>{{`${selectedGridReportResult.orig_thres_info.user_username} - ${selectedGridReportResult.report_name}`}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6"><v-text-field label="Date" :value="formatReportRunTime(selectedGridReportResult.orig_thres_info.last_ran_at)" dense disabled /></v-col>
                        <v-col cols="12" sm="6"><v-text-field label="Threshold" v-model="selectedGridReportResult.threshold_text" dense disabled /></v-col>
                        <v-col cols="12" sm="12"><v-text-field label="Parameters" v-model="selectedGridReportResult.thres_human_params" dense disabled /></v-col>
                        <v-col cols="12" sm="6"><v-text-field label="Format" v-model="selectedGridReportResult.thres_method_text" dense disabled /></v-col>
                        <v-col cols="12" sm="6"><v-text-field label="Criteria" v-model="selectedGridReportResult.thres_criteria_text" dense disabled /></v-col>
                        <v-col cols="12" sm="6"><v-text-field label="Sort and Limit" v-model="selectedGridReportResult.thres_sort_limit_text" dense disabled /></v-col>
                        <v-col cols="12" sm="6"><v-text-field label="Filter" v-model="selectedGridReportResult.thres_filter_text" dense disabled /></v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn text @click="showReportInfo = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showReportNotes" max-width="80%" width="1600px" persistent v-if="showReportNotes" @keydown="(k) => {k.key == 'Escape' ? showReportNotes = false : null}">
            <report-notes :notes="selectedGridReportResult.notes" @close="showReportNotes = false" v-if="showReportNotes"></report-notes>
        </v-dialog>
    </v-container>

</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import ReportResults from '@/components/Reports/ReportResults';
import ReportNotes from '@/components/Reports/ReportNotes';
export default {
    name: 'SpecialReports',
    props: [],
    components: {
        'ag-grid-vue': AgGridVue,
        ReportResults,
        ReportNotes
    },
    data: () => ({
        currentStep: 1,
        selectedReportType: null,
        selectedReportTypeName: null,
        selectedReportInfo: null,
        htmlReportResults: null,
        gridReportResults: null,
        selectedGridReportResult: null,
        gettingThresReptFileList: false,
        showSpecialReportResults: false,
        showReportInfo: false,
        noResults: false,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`
        },

        showThresReptFileBrowser: false,
        thresreptFiles: null,
        showReportNotes: false
    }),

    computed: {
        specialReportsTypes: function() {
            if(this.$store.state.batchConfig.special_reports && this.$store.state.batchConfig.special_reports.length && this.$store.state.batchConfig.special_reports[0].length) {
                let values = this.$store.state.batchConfig.special_reports[0];
                let names = this.$store.state.batchConfig.special_reports[1];
                let types = [];

                for(let [idx, value] of values.entries()) {
                    types.push({
                        value: value,
                        text: names[idx]
                    });
                }
                return types;
            }
            else {
                return [];
            }
        },

        paramsText: function() {
            if(!this.selectedReportInfo) {
                return '';
            }
            let text = '';
            for(let [idx, param] of this.selectedReportInfo.entries()) {
                text += `${param.name}: ${param.value}${(idx == this.selectedReportInfo.length - 1 ? '' : ', ')}`;
            }
            return text;
        }

    },

    methods: {
        getSpecialReportInfo: function(reportType) {
            this.selectedReportType = reportType.value;
            this.selectedReportTypeName = reportType.text;
            let route = (TELSA.apiHost + "report/special/info");
            TELSA.loading(true);
            return this.$http.post(route, {args: {reportType: reportType.value}}).then(response => {
                let results = response.body;
                this.setValues(results);
                this.currentStep = 2;
                TELSA.loading(false);
            });
        },

        updateSpecialReportParams: function(param) {
            if(param.name.toLowerCase() == 'date') {
                return;
            }
            let values = [];
            for(let param of this.selectedReportInfo) {
                if(param.name.toLowerCase() != 'date') {
                    values.push(param.value);
                }
            }
            let route = (TELSA.apiHost + "report/special/update");
            TELSA.loading(true);
            return this.$http.post(route, {args: {reportType: this.selectedReportType, values: values}}).then(response => {
                let results = response.body;
                this.setValues(results);
                TELSA.loading(false);
            });
        },

        setValues: function(values) {
            this.selectedReportInfo = values;
            for(let param of this.selectedReportInfo) {
                param.value = param.vals.length ? param.vals[param.default] : '';
            }
        },

        runSpecialReport: function() {
            this.htmlReportResults = null;
            this.gridReportResults = null;
            this.selectedGridReportResult = null;
            this.showSpecialReportResults = false;
            let values = [];
            for(let param of this.selectedReportInfo) {
                values.push(param.value);
            }
            let route = (TELSA.apiHost + "report/special/run");
            TELSA.loading(true);
            return this.$http.post(route, {args: {reportType: this.selectedReportType, values: values}}).then(response => {
                let results = response.body;
                if(this.selectedReportType == 'thres') {
                    if(!results || !results.length) {
                        this.noResults = true;
                        TELSA.loading(false);
                        return;
                    }
                    this.noResults = false;
                    // Format results to use the ReportResults component
                    for(let result of results){
                        result.specialReport = true;

                        //result.user_obj_name = result.report_name
                        result.user_obj_name = result.orig_thres_info.user_obj_name;

                        result.history = false;
                        result.data = result.rows;
                    }
                    this.gridReportResults = results;
                    this.selectedGridReportResult = this.gridReportResults[0]
                    this.showSpecialReportResults = true;
                }
                else {
                    this.htmlReportResults = results;
                }
                this.currentStep = 3;
                TELSA.loading(false);
            });
        },

        printSpecialReportResults: function() {
            let width = (0.8 * screen.width);
            let height = (0.8 * screen.height);
            let printWindow = window.open('', 'PRINT', `height=${height},width=${width}`);

            let contents = `
                <div style="border-bottom: black solid 1px; text-align: center;">
                    <h1>${this.selectedReportTypeName}</h1>
                    <span>${this.paramsText}</span>
                </div>
                ${this.htmlReportResults}
            `;

            printWindow.document.write(contents);
            printWindow.print();
            printWindow.close();
        },

        reloadReportResults: function(specialReportUniqueId) {
            for(let specialReport of this.gridReportResults) {
                if(specialReport.unique_id == specialReportUniqueId) {
                    this.selectedGridReportResult = specialReport;
                }
            }
            this.showSpecialReportResults = false;
            this.$nextTick(() => {
                this.showSpecialReportResults = true;
            })
        },

        formatReportRunTime: function(datetime) {
            return TELSA.moment(datetime).format('MM/DD/YYYY HH:mm:ss');
        },

        getFileBrowserData: function() {
            if(this.showThresReptFileBrowser) {
                this.showThresReptFileBrowser = false;
                return;
            }
            let route = (TELSA.apiHost + "report/special/thresreptmeta");
            this.gettingThresReptFileList = true;
            return this.$http.get(route).then(response => {
                let result = response.body;
                console.log(result);
                this.thresreptFiles = result;
                this.showThresReptFileBrowser = true;
                this.gettingThresReptFileList = false;
            });
        },

        downloadThresreptFile: function(user, file) {
            let dlink = document.createElement('a');
            let url = new URL(`${TELSA.staticHost}thresrept-files/${user}/${file}?username=${this.$store.state.user.user_username}&access=${this.$store.state.user.user_access}`);
            dlink.href = url;
            dlink.click();
            dlink.remove();
        },

        getFileIcon: function(fileName) {
            return TELSA.getFileIcon(fileName);
        },

        getPrettyFileSize: function(fileSize) {
            return TELSA.readableFileSize(fileSize);
        }
    },

    mounted() {
    }
};
</script>

<style scoped>

    .placeholder-text {
        color: rgba(255, 255, 255, 0.5);
        display: block;
        font-size: 18pt;
        text-align: center;
        margin-top: 30vh;
    }

    .no-special-reports-text {
        text-align: center;
        font-size: 16pt;
        font-family: "Roboto", sans-serif !important;
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100% - 2em);
    }

    @media screen and (max-width: 600px) {
        .no-special-reports-text {
            font-size: 12pt;
        }
    }

    .stepper {
        background: #424242;
        height: calc(100vh - 80px);
        width: 100%;
    }
    .stepper .stepper-step {
        padding: 12px 24px;
    }
    .stepper-content-container {
        overflow-y: auto; 
        height: calc(100% - 55px);
    }
    .stepper-content {
        padding: 16px;
    }
    .stepper-content.less-pad {
        padding: 16px 4px 4px 4px;
    }



    .list-report-container {
        background-color: #303030;
        color: #ffffff;
        height: 40px;
        padding: 8px;
        cursor: pointer;
        border: solid 1px #212121;
        border-radius: 2px;
        font-weight: bold;
    }
    .list-report-container:hover {
        box-shadow: 4px 4px 5px -2px rgba(0, 0, 0, 0.6);
        color: #c42111;
    }


    .results-header {
        background-color: #ffffff;
        color: #000000;
        text-align: center;
        border-bottom: #000000 solid 1px;
        padding: 0.25em 0;
    }
    .results-header .print {
        position: absolute;
        top: 3.5em;
        right: 4em;
    }

    .results-container {
        background-color: #ffffff;
        padding: 2em 2em 0 2em;
        color: #000000;
        overflow-x: scroll;
        overflow: auto;
        /* margin: 2em; */
    }

    .no-results {
        text-align: left;
        font-size: 18pt;
        margin-top: 2em;
        margin-left: 3em;
        animation: shake-horizontal 0.3s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
    }
    @keyframes shake-horizontal {
        0%,
        100% {
            transform: translateX(0);
        }
        10%,
        30%,
        50%,
        70% {
            transform: translateX(-10px);
        }
        20%,
        40%,
        60% {
            transform: translateX(10px);
        }
        80% {
            transform: translateX(8px);
        }
        90% {
            transform: translateX(-8px);
        }
    }


    .thresrept-files-button {
        background-color: #303030;
        border: #000000 solid 1px;
        border-radius: 3px;
        height: 3em;
        width: 16em;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
        margin-top: 2em;
        display: inline-block;
    }
    .thresrept-files-button span {
        display: block;
    }
    .thresrept-files-button:hover {
        box-shadow: 4px 4px 5px -2px rgba(0, 0, 0, 0.6);
        font-weight: bold;
    }

    .getting-files-list-text {
        display: inline-block;
        font-size: 18px;
        margin-left: 1em;
    }

    .getting-files-list-text i {
        vertical-align: baseline;
    }

    .thresrept-files-container {
        border: #000000 solid 1px;
    }

    .thresrept-files-container .download-link {
        cursor: pointer;
        text-decoration: underline;
        margin-right: 2em;
    }

</style>
